import { ChevronRightIcon, PlusIcon } from 'lucide-react';

import { Alert, AlertAction, AlertDescription } from '@nesso/ui/primitives/alert';
import { Button } from '@nesso/ui/primitives/button';

export function ClientDetailsDiagnosisTreatment() {
    return (
        <div className="flex flex-col gap-4 pb-2">
            <Button type="button" variant="ghost" size="sm" className="w-fit -ml-2.5">
                <PlusIcon className="size-4" />
                Add Diagnosis
            </Button>
            <Alert
                variant="secondary"
                orientation="horizontal"
                className="py-4 gap-x-0 bg-secondary-background/50"
            >
                <AlertDescription className="font-bold">No treatment goals yet</AlertDescription>
                <AlertAction>
                    <Button type="button" variant="ghost" size="sm">
                        Add Treatment Plan
                        <ChevronRightIcon className="size-4" />
                    </Button>
                </AlertAction>
            </Alert>
        </div>
    );
}
